// extracted by mini-css-extract-plugin
module.exports = {"accordion-item":"styles_accordion-item__1sQGf","title":"styles_title__b1IKU","active":"styles_active__1BvJw","icon":"styles_icon__2Mg17","body":"styles_body__3CroH"};